import { normalizeSeed } from '~/boggle/engine/core'
import type { BoggleGameModeId } from '~/boggle/gameModes'
import type { BoggleCompletedRun } from './types'

export function toBoggleChallengeProgressKey(seed: number | string) {
  return String(normalizeSeed(seed))
}

function readCompletedRunScore(run: BoggleCompletedRun) {
  const total = run.summarySnapshot?.total
  return typeof total === 'number' && Number.isFinite(total) && total >= 0 ? total : null
}

function readChallengeProgressSeed(run: BoggleCompletedRun) {
  const progressSeed = run.setupSnapshot?.challenge?.progressSeed
  if (progressSeed === undefined) {
    return null
  }

  return toBoggleChallengeProgressKey(progressSeed)
}

export function getBoggleStandardBestScoreFromRuns(
  completedRuns: readonly BoggleCompletedRun[],
  gameModeId: BoggleGameModeId,
) {
  let bestScore: number | null = null

  for (const run of completedRuns) {
    if (run.gameModeId !== gameModeId || run.runKind !== 'standard') {
      continue
    }

    const score = readCompletedRunScore(run)
    if (score === null) {
      continue
    }

    bestScore = bestScore === null ? score : Math.max(bestScore, score)
  }

  return bestScore
}

export function getBoggleChallengeBestScoreFromRuns(
  completedRuns: readonly BoggleCompletedRun[],
  gameModeId: BoggleGameModeId,
  progressSeed: number | string,
) {
  const progressKey = toBoggleChallengeProgressKey(progressSeed)
  let bestScore: number | null = null

  for (const run of completedRuns) {
    if (run.gameModeId !== gameModeId || run.runKind !== 'challenge') {
      continue
    }

    if (readChallengeProgressSeed(run) !== progressKey) {
      continue
    }

    const score = readCompletedRunScore(run)
    if (score === null) {
      continue
    }

    bestScore = bestScore === null ? score : Math.max(bestScore, score)
  }

  return bestScore
}
